import { Landmark, ShieldCheck, LineChart, Radio, CreditCard, Building2, Factory, Sprout } from "lucide-react";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";
import CtaBand from "@/components/CtaBand";
import { industries } from "@/data/site";

const iconMap = { Landmark, ShieldCheck, LineChart, Radio, CreditCard, Building2, Factory, Sprout };

export default function Industries() {
  return (
    <>
      <Seo
        title="Industries | Incremental Consulting"
        description="Delivery experience across South Africa's most regulated sectors — banking, insurance, asset management, telecommunications and payments."
      />
      <section className="bg-[#0B1F3A]">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-24">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#C9A227]" data-testid="industries-eyebrow">Industries</p>
            <h1 className="mt-3 max-w-3xl text-balance font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl" data-testid="industries-page-title">
              Regulated environments we know.
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/70">
              We are already delivering across banking, asset management and telecommunications. Our delivery method is built for environments where deadlines are set by regulators, not by preference.
            </p>
          </Reveal>
        </div>
      </section>
      <section className="bg-[#F5F8FC]">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-24">
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-testid="industries-grid">
            {industries.map((ind, i) => {
              const Icon = iconMap[ind.icon];
              return (
                <Reveal key={ind.name} delay={(i % 4) * 0.08}>
                  <div
                    className="group flex h-full items-center gap-3 rounded-xl border border-[#0B1F3A]/10 bg-white px-5 py-5 transition-all duration-300 hover:border-[#C9A227]/60 hover:shadow-[0_12px_28px_-14px_rgba(11,31,58,0.25)]"
                    data-testid={`industries-page-card-${ind.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  >
                    <Icon size={20} className="shrink-0 text-[#A87B1F]" />
                    <span className="text-sm font-semibold text-[#172033]">{ind.name}</span>
                  </div>
                </Reveal>
              );
            })}
          </div>
          <Reveal delay={0.2}>
            <p className="mt-12 max-w-2xl text-sm leading-relaxed text-[#667085]" data-testid="industries-adaptable-note">
              Every regulated environment has its own scrutiny. We adapt our delivery and governance approach to your regulator, your audit committee and your deadlines.
            </p>
          </Reveal>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
